import { useContext } from 'react';
import { useMRTableModalsContext } from '../context/MRTableModalsContext';
import StoreContext from '../context/StoreContext';
import EditPhoneModal from './EditPhoneModal';
import NextApptModal from './NextApptModal';
import NextApptReadModal from './NextApptReadModal';
import FeedbackPopUp from './FeedbackPopUp';
import LyftDialog from './LyftDialog';
import LyftRideStatusDialog from './LyftRideStatusDialog';
import LyftRideCanceledDialog from './LyftRideCanceledDialog';
import WorkOrderContext from '../context/WorkOrderContext';

const MRTableModals = ({
  updatePhone,
  currentWorkOrder,
  setCurrentWorkOrder
}) => {
  const {address} = useContext(StoreContext)
  const { canceledLyftWorkOrder } = useContext(WorkOrderContext)

  const {
    isPhoneEditOpen,
    togglePhoneEdit,
    openNextAppt,
    openReadAppt,
    onCloseNextAppt,
    onCloseReadAppt,
    openLyftDialog,
    onOpenLyftStatusDialog,
    openLyftStatusDialog,
    onCloseLyftDialog,
    onCloseLyftStatusDialog,
    isFirstTimeLyftStatusModalOpen,
    setIsFirstTimeLyftStatusModalOpen,
    openErrorPopUp,
    onCloseErrorPopup,
    setOpenErrorPopup,
    errorMessage,
    setErrorMessage,
    openCanceledRide,
    onCloseCanceledRide,
    openRequestRideDialog
  } = useMRTableModalsContext();

  return (
    <>
      {isPhoneEditOpen && 
        <EditPhoneModal 
          toggleModal={togglePhoneEdit} 
          updatePhone={updatePhone}
        />
      }
      {openNextAppt && 
        <NextApptModal
          open={openNextAppt}
          onClose={onCloseNextAppt}
          woData={currentWorkOrder}
          setOpenErrorPopup={setOpenErrorPopup}
          setErrorMessage={setErrorMessage}
        />
      }
      {openReadAppt && 
        <NextApptReadModal
          open={openReadAppt}
          onClose={onCloseReadAppt}
          woData={currentWorkOrder}
          setOpenErrorPopup={setOpenErrorPopup}
          setErrorMessage={setErrorMessage}
        />
      }
      {openErrorPopUp && 
        <FeedbackPopUp
          open={openErrorPopUp}
          onClose={onCloseErrorPopup}
          title={'Something went wrong!'}
          message={errorMessage}
          type={'error'}
        />
      }
      {openLyftDialog && 
        <LyftDialog
          open={openLyftDialog}
          onClose={onCloseLyftDialog}
          firstName={currentWorkOrder.FirstName}
          lastName={currentWorkOrder.LastName}
          phoneNumber={currentWorkOrder.Phone}
          WO={currentWorkOrder.WO}
          storeNo={currentWorkOrder.SiteNo}
          pickupAddress={address}
          dropOffAddress={ 
            (currentWorkOrder.customer_address && currentWorkOrder.customer_address_city)
            ?  [currentWorkOrder.customer_address, currentWorkOrder.customer_address_city, currentWorkOrder.customer_address_state, currentWorkOrder.customer_address_postal]
                .filter(field => field && field.trim())
                .join(' ')
            : ''
          }
          onOpenLyftStatusDialog={onOpenLyftStatusDialog}
        />
      }
      {openLyftStatusDialog && 
        <LyftRideStatusDialog
          open={openLyftStatusDialog}
          onClose={onCloseLyftStatusDialog}
          rideInfo={currentWorkOrder?.CourtesyRidesData[0]}
          siteNo={currentWorkOrder.SiteNo}
          isFirstTimeOpen={isFirstTimeLyftStatusModalOpen}
          setIsFirstTimeOpen={setIsFirstTimeLyftStatusModalOpen}
        />
      }

      {openCanceledRide &&
        <LyftRideCanceledDialog
          open={openCanceledRide}
          onClose={onCloseCanceledRide}
          WO={canceledLyftWorkOrder?.WO}
          customerName={canceledLyftWorkOrder?.Name}
          mobile={canceledLyftWorkOrder?.Phone}
          setCurrentWorkOrder={setCurrentWorkOrder}
          openRequestRideDialog={openRequestRideDialog}
        /> 
      }

    </>
  );
};

export default MRTableModals;
